<template lang="pug">
  .dashboard-card.md-layout-item.md-size-33
    md-card
      md-card-header
        div(class="md-title") {{this.name}}
      md-card-content
        md-list(v-if="loaded && stocks && stocks.length")
          md-list-item(v-for="stock in stocks" v-bind:key="stock.id")
            router-link(v-bind:to="{name: 'Stock', params: {stock_id: stock.id}}" class="md-list-item-text") {{stock.name}}
            span(class="md-list-action") {{'Грузов: ' + stock.freight_count}}
        p(v-if="!loaded") Загрузка...
        p(v-if="loaded && (!stocks || !stocks.length)") У вас не созданно ни одного склада
</template>

<script>
  export default {
    module: 'stocks',
    data() {
      return {
        name: 'Количество груза на складе',
        uniqueCode: 'stock',
        module: 'stocks',
        loaded: false
      }
    },
    computed: {
      stocks() {
        return this.$store.state.stock.stocks
      }
    },
    methods: {
      getStocks() {
        this.$store.dispatch('stock/getStocks', {page: 1, count: 100}).then(() => {
          this.loaded = true;
        });
      },
      toTraking(stock_id) {
        this.$cookie.set('filterFreightByStock', stock_id, { expires: '1M' });
        this.$router.push({ name: 'Freights'});
      },
    },
    created() {
      this.getStocks();
    }
  }
</script>
<style lang="sass">
    .dashboard-card
      .md-list
        background-color: #fff
</style>



// WEBPACK FOOTER //
// StockDashboard.vue?661df5f8